const firebaseConfig = {
    apiKey: "AIzaSyDzPwcW7C054QC7I4seigs5ZP34bK1etAI",
    authDomain: "travel-world-8187d.firebaseapp.com",
    projectId: "travel-world-8187d",
    storageBucket: "travel-world-8187d.appspot.com",
    messagingSenderId: "193220928266",
    appId: "1:193220928266:web:fd2d50190cee53cdb050f3"
  };
  export default firebaseConfig;  